export default __webpack_public_path__ + "static/media/Icon=Team.15dd450b.svg";